export const GET_PROJECT = "GET_PROJECT";
export const GET_LANGUAGES = "GET_LANGUAGES";
export const GET_PROJECTS = "GET_PROJECTS";
